const catalogos = {
  PROVINCIA: ['BuscarProvincia', null],
  MUNICIPIO: ['BuscarMunicipio', 'ProvinciaId'],
  BARRIO: ['BuscarBarrio', 'MunicipioId'],
  SUBBARRIO: ['BuscarSubBarrio', 'BarrioId'],
};

// Las mismas estructuras territoriales de Citrus. Solo consultas; no crea catálogos.
export const consultarUbicaciones = async (nivel, padre) => {
  const config = catalogos[nivel];
  if (!config) throw new Error('Catálogo geográfico no válido.');
  const [metodo, relacion] = config;
  if (relacion && !(Number(padre) > 0)) return [];
  const resultados = [];
  for (let pagina = 0; pagina < 100; pagina += 1) {
    const where = { Pais: 'DO', EsPaginable: true, IndiceDePagina: pagina, CantidadPorPagina: 500 };
    if (relacion) where[relacion] = Number(padre);
    const datos = await new Promise((resolve, reject) => {
      // eslint-disable-next-line no-undef
      $.ajax({
        type: 'POST', contentType: 'application/json; charset=utf-8', dataType: 'json', timeout: 30000,
        url: `/Public/WebService/PublicWebService.asmx/${metodo}`, data: JSON.stringify({ where }),
        success: response => {
          try {
            const body = response?.d ?? response;
            const parsed = typeof body === 'string' ? JSON.parse(body) : body;
            if (!Array.isArray(parsed?.Resultados)) throw new Error('No se pudo cargar el catálogo geográfico.');
            resolve(parsed);
          } catch (error) { reject(error); }
        },
        error: () => reject(new Error('No se pudo cargar el catálogo geográfico. Inténtalo nuevamente.')),
      });
    });
    resultados.push(...datos.Resultados);
    if (datos.Resultados.length < 500 || (Number(datos.Total) > 0 && resultados.length >= Number(datos.Total))) {
      return resultados.sort((a, b) => a.Nombre.localeCompare(b.Nombre, 'es') || Number(a.Id) - Number(b.Id));
    }
  }
  throw new Error('El catálogo geográfico no se pudo cargar completo.');
};
